import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  signal,
} from '@angular/core';

import { AppSharedModule } from '../../../../../../../app-shared.module';
import { BaseSectionComponent } from '../base-section';

@Component({
  selector: 'app-summary-section',
  imports: [AppSharedModule],
  templateUrl: './summary-section.component.html',
  styleUrl: './summary-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SummarySectionComponent extends BaseSectionComponent {
  isLastSection = input<boolean>();

  isExpanded = signal<boolean>(true);

  toggleExpansion($event) {
    $event.detail.nativeEvent.stopImmediatePropagation();

    this.isExpanded.set(!this.isExpanded());
  }
}
